import React from 'react';

import { styled, Tooltip, makeStyles } from '@gogame/components';

export const ThumbnailImage = styled('img')`
  width: 100%;
  height: 100%;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  background: ${({ theme }) => theme.palette.inactive.main};
  border-radius: 20%;
  overflow: hidden;
  flex-shrink: 0;
`;

export const PreviewImage = styled('img')`
  max-width: 500px;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
`;

const useStyles = makeStyles(() => ({
  tooltip: {
    padding: '8px',
    maxWidth: 'none',
  },
}));

export const Image = styled(
  ({ imageUrl, title, fullImageUrl, className, onClick }) => {
    const classes = useStyles();
    return (
      <div className={className}>
        <Tooltip
          placement={'right'}
          wrapper
          classes={{
            tooltip: classes.tooltip
          }}
          title={<PreviewImage src={fullImageUrl} onClick={onClick} />}
        >
          <ThumbnailImage src={imageUrl} title={title} onClick={onClick} />
        </Tooltip>
      </div>
    );
  }
)`
  width: 30px;
  height: 30px;
  background: ${(props) => props.theme.palette.inactive.main};
  border-radius: 20%;
  overflow: hidden;
  flex-shrink: 0;
`;

export default Image;
